import { CompetitionLevelCards } from "./CompetitionLevelCards";

export const Home = () => {
  return (
    <div className="flex flex-col h-full items-center gap-2 overflow-hidden">
      <div className="grid grid-cols-1 xl:grid-cols-6 gap-2 w-full h-full">
        <CompetitionLevelCards />
      </div>
    </div>
  );
};
